import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import memoize from 'react-utils/memoize';
import { css } from 'foundations-theming/utils';
import styled from 'foundations-theming/utils';
import { WellContextConsumer } from './WellContext';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const Inner = styled.div.withConfig({
  displayName: "WellItem__Inner",
  componentId: "d2urc8-0"
})(["text-align:center;max-width:none;"]);
const verticalMixin = css(["display:flex;flex-basis:auto;justify-content:center;"]);
const getStyledWellItem = memoize(WellItemComponent => styled(WellItemComponent).withConfig({
  displayName: "WellItem__getStyledWellItem",
  componentId: "d2urc8-1"
})(["position:relative;flex:1 1 180px;padding:0 12px 0 0;margin-top:18px;margin-bottom:32px;", " ", ""], ({
  $orientation
}) => $orientation === 'vertical' && verticalMixin, ({
  $cssStyles
}) => $cssStyles));
export const WellItem = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(WellContextConsumer, {
    children: ({
      WellItemComponent,
      orientation
    }) => {
      const StyledWellItem = getStyledWellItem(WellItemComponent);
      return /*#__PURE__*/_jsx(StyledWellItem, Object.assign({
        $orientation: orientation,
        $cssStyles: cssStyles
      }, domProps, {
        children: /*#__PURE__*/_jsx(Inner, {
          children: children
        })
      }));
    }
  });
};